import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { camposAPI, partidasAPI } from '../services/api';
import './CreateGame.css';

function CreateGame() {
  const navigate = useNavigate();
  const [campos, setCampos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    nombre: '',
    handicap: '',
    campoId: ''
  });

  useEffect(() => {
    loadCampos();
  }, []);

  const loadCampos = async () => {
    try {
      const response = await camposAPI.getAll();
      setCampos(response.data);
      if (response.data.length > 0) {
        setFormData(prev => ({ ...prev, campoId: response.data[0].id }));
      }
    } catch (err) {
      console.error('Error al cargar campos:', err);
      console.error('Error details:', err.message, err.response);
      const errorMsg = err.response?.data?.error || err.message || 'Error al cargar los campos de golf';
      setError(`Error al cargar campos: ${errorMsg}. Verifica tu conexión a internet.`);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'handicap' || name === 'campoId' ? Number(value) : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.nombre.trim()) {
      setError('Por favor, escribe tu nombre');
      return;
    }

    if (!formData.campoId) {
      setError('Por favor, selecciona un campo de golf');
      return;
    }

    setCreating(true);

    try {
      const response = await partidasAPI.create({
        campoId: formData.campoId,
        jugador: {
          nombre: formData.nombre.trim(),
          handicap: formData.handicap === '' ? 0 : Number(formData.handicap)
        }
      });

      // Guardar datos en localStorage
      localStorage.setItem('partidaCodigo', response.data.codigo);
      localStorage.setItem('jugadorId', response.data.jugadorId);
      localStorage.setItem('jugadorNombre', formData.nombre.trim());

      // Redirigir a sala de espera
      navigate(`/sala/${response.data.codigo}`);
    } catch (err) {
      console.error('Error al crear partida:', err);
      setError(err.response?.data?.error || 'Error al crear la partida. Inténtalo de nuevo.');
    } finally {
      setCreating(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p style={{ marginTop: '20px', color: '#2e7d32' }}>Cargando campos...</p>
      </div>
    );
  }

  return (
    <div className="create-game">
      <div className="header">
        <h1>Crear Nueva Partida</h1>
        <p>Configura tu partida de golf</p>
      </div>

      <div className="container">
        <div className="card fade-in">
          {error && <div className="error">{error}</div>}

          {campos.length === 0 ? (
            <div className="no-campos">
              <p>No hay campos de golf disponibles.</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/admin/campos')}
              >
                Crear Campo
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="nombre">Tu Nombre</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder="Ej: Juan Pérez"
                  required
                  maxLength="50"
                />
              </div>

              <div className="form-group">
                <label htmlFor="handicap">Tu Handicap</label>
                <input
                  type="number"
                  id="handicap"
                  name="handicap"
                  value={formData.handicap}
                  onChange={handleChange}
                  placeholder="Ej: 18.5"
                  min="0"
                  max="54"
                  step="0.1"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="campoId">Campo de Golf</label>
                <select
                  id="campoId"
                  name="campoId"
                  value={formData.campoId}
                  onChange={handleChange}
                  required
                >
                  {campos.map(campo => (
                    <option key={campo.id} value={campo.id}>
                      {campo.nombre} ({campo.num_hoyos} hoyos)
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-full"
                disabled={creating}
              >
                {creating ? 'Creando...' : 'Crear Partida'}
              </button>

              <button
                type="button"
                className="btn btn-secondary btn-full"
                onClick={() => navigate('/')}
                style={{ marginTop: '12px' }}
              >
                Cancelar
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateGame;
